<template>
  <div class="definitions">
    <h2 class="definitions__title mb-l">Определения конкурса</h2>
    <div class="definitions__tags">
      <span
        v-for="(s, idx) in definitions"
        :key="idx"
        :class="{ 'is-active': selectedDefinition === s.id }"
        class="definitions__tags-item"
        tabindex="0"
        @click="setDatePreset(s.id)"
        >{{ s.title }}</span
      >
    </div>

    <div class="definitions__carousel">
      <Carousel
        :carousel-data="definitions"
        :selected-data="selectedDefinition"
        @changeSlide="setDatePreset"
      >
        <template #carousel-data="{ carouselData }">
          <p class="definitions__carousel-item">{{ carouselData.text }}</p>
        </template>
      </Carousel>
    </div>

    <div v-if="definition" class="definitions__tags-description">
      {{ definition }}
    </div>
  </div>
</template>

<script>
import Carousel from "@/components/Carousel";
export default {
  name: "ContestDefinitions",
  components: { Carousel },
  data() {
    return {
      selectedDefinition: "nomination",
      definitions: [
        {
          title: "Номинация",
          text: "Номинация — это общий принцип награждения участников внутри трека. В каждом треке в каждой возрастной лиге в номинации «Лучший кружок 2023» определяется Победитель и Призеры Конкурса. Партнеры Конкурса могут дополнительно заявить собственные номинации внутри треков, с отличными критериями оценивания.",
          id: "nomination",
        },
        {
          title: "Участник",
          text: "Участник — это любой заявитель Конкурса, заявка которого была принята на рассмотрение жюри.",
          id: "participant",
        },
        {
          title: "Трек",
          text: "Трек — это направление конкурса, которое выбирает участник в соответствии со своим самоопределением. Вопросы анкеты и критерии оценивания в разных треках отличаются. Треки нужны, чтобы разнородные по ключевой деятельности кружки и сообщества соревновались с себе подобными.",
          id: "track",
        },
        {
          title: "Лига",
          text: "Лига — определяется возрастом участников кружка. Организаторы Конкурса настоятельно рекомендуют выбрать одну лигу в одном треке. При острой необходимости, Кружок может участвовать более чем в одной лиге при условии разной деятельности участников разных возрастных групп. При этом, подать заявку от одного кружка в другую возрастную лигу можно только при разных заявителях. Для этого второй заявитель должен тоже быть зарегистрирован как платформе Талант и подать отдельную заявку в другую лигу.",
          id: "league",
        },
      ],
    };
  },
  computed: {
    definition() {
      return this.definitions.find((item) => {
        return item.id === this.selectedDefinition;
      })?.text;
    },
  },
  methods: {
    setDatePreset(id) {
      if (typeof id === "object") {
        this.selectedDefinition = id?.id;
        return;
      }
      this.selectedDefinition = id;
    },
  },
};
</script>

<style lang="less" scoped>
.definitions {
  &__title {
    font-size: @font-size-h2;
    line-height: @line-height-h2;
    max-width: 720px;
    text-align: center;
    font-weight: 700;
    margin: 0 auto;
  }

  &__carousel {
    min-height: 252px;
    display: flex;
    border: 1px solid @blue-color;
    border-radius: @border-radius-xs;

    &-item {
      max-width: 660px;
      margin: 0 auto;
      align-self: center;
      justify-self: center;
      user-select: none;
    }
  }
  &__tags {
    margin-left: -5px;
    margin-right: -5px;
    position: relative;
    margin-bottom: @margin-l;
    text-align: center;

    &-item {
      background-color: #fff;
      display: inline-block;
      padding: 5px 15px;
      font-size: @font-size-s;
      line-height: @line-height-s;
      color: @primary-color;
      border: 1px solid @blue-color;
      border-radius: @border-radius-xs;
      margin: 0 @margin-xs @margin-s;
      position: relative;
      transition: color 0.3s, border-color 0.3s, background-color 0.3s;
      cursor: pointer;
      user-select: none;

      &:hover {
        border-color: darken(@blue-color, 10%);
      }

      &.is-active {
        background-color: @base-color;
        border: none;
        color: #fff;
        cursor: default;
      }
    }

    &-description {
      padding: 20px;
      border-radius: @border-radius-xs;
      border: 1px solid @blue-color;
      background-color: #fff;
      display: none;
    }
  }

  @media (max-width: @screen-xs) {
    &__title {
      font-size: @font-size-h4;
      line-height: @line-height-h4;
    }
  }

  @media (max-width: @screen-xs-max) {
    &__tags {
      &-description {
        display: block;
      }
    }
    &__carousel {
      display: none;
    }
  }
}
</style>
